import axios, { isAxiosError } from "axios";
import { get } from "lodash";
export class BaseConnector {
    http;
    constructor(_settings) {
        this.http = axios.create();
    }
    async get(endpoint, configOverrides) {
        const url = urljoin(this.baseUrl, endpoint);
        const requestConfig = await this.getRequestConfig();
        const res = await this.http.get(url, { ...requestConfig, ...(configOverrides ?? {}) });
        return {
            payload: res.data,
            statusCode: res.status,
            statusText: res.statusText,
            headers: res.headers,
        };
    }
    async post(endpoint, data, configOverrides) {
        const url = urljoin(this.baseUrl, endpoint);
        const requestConfig = await this.getRequestConfig();
        try {
            const res = await this.http.post(url, data, { ...requestConfig, ...(configOverrides ?? {}) });
            return {
                payload: res.data,
                statusCode: res.status,
                statusText: res.statusText,
                headers: res.headers,
            };
        }
        catch (err) {
            if (isAxiosError(err)) {
                // NOTE: this is important for showing the daily limit exceeded message
                const detailedMessage = get(err.response?.data, "Errors[0].Message");
                if (detailedMessage) {
                    err.message += `: ${detailedMessage}`;
                }
            }
            throw err;
        }
    }
    // eslint-disable-next-line @typescript-eslint/member-ordering
    async getRequestConfig() {
        return {};
    }
}
export function urljoin(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
//# sourceMappingURL=baseConnector.js.map